import { Tabs, Tab } from "@mui/material"
import router from "next/router"
import { useState } from "react"

const EMAILS_TEMPLATES_TAB_KEY = "emails-templates"
const EMAILS_DOMAIN_CORRECTION_TAB_KEY = "emails-domain-correction"

type EmailsTabKey = typeof EMAILS_TEMPLATES_TAB_KEY | typeof EMAILS_DOMAIN_CORRECTION_TAB_KEY

interface EmailsTabsProps {
  route: string
  defaultTabState: EmailsTabKey
}

export const EmailsTab = ({ defaultTabState, route }: EmailsTabsProps) => {
  const [tab, setTab] = useState<EmailsTabKey>(defaultTabState)

  const goTo = async () => await router.push(route)

  return (
    <>
      <Tabs value={tab} sx={{ flexGrow: 1 }}>
        <Tab value={EMAILS_TEMPLATES_TAB_KEY} label="Emails Templates" onClick={goTo} />
        <Tab
          value={EMAILS_DOMAIN_CORRECTION_TAB_KEY}
          label="Emails Domain Correction"
          onClick={goTo}
        />
      </Tabs>
    </>
  )
}
